/* istanbul ignore file */
import React, { useRef, useState } from 'react';
// Brightcove component does not support TS
/* @ts-ignore */
import ReactPlayerLoader from '@brightcove/react-player-loader';
import { IconButton } from "@hm-group/fabric-components/components/Buttons";
import { Image } from "@hm-group/fabric-components/components/Image";
import { MediaPauseIconMedium } from "@hm-group/fabric-icons/icons/MediaPauseIcon";
import { MediaPlayIconMedium } from "@hm-group/fabric-icons/icons/MediaPlayIcon";
import { isClient } from "@hm-group/frontend-utils/common";
import cn from 'classnames';
import setVideoSchema from './helpers/setVideoSchema';
import trackVideo from './helpers/tracking';
import "./ProductVideo.css";
var styles = { "pdpVideo": "e7c4ce", "posterImage": "ff6a59", "vjs-tech": "vjs-tech", "vjs-has-started": "vjs-has-started", "video-js": "video-js", "vjs-poster": "vjs-poster", "vjs-big-play-button": "vjs-big-play-button", "vjs-modal-dialog": "vjs-modal-dialog", "vjs-contextmenu-ui-menu": "vjs-contextmenu-ui-menu", "vjs-text-track-display": "vjs-text-track-display", "vjs-dock-text": "vjs-dock-text", "vjs-dock-shelf": "vjs-dock-shelf", "vjs-control-bar": "vjs-control-bar", "vjs-playing": "b15e8c", "videoOverlay": "bd1144" };
import IntersectionVisible from '../IntersectionVisible';
const ProductVideo = ({ videoId, description, name, posterImage, intersectionVisibleOptions, labels, autoplay = false, loop = false, trackingData, options, className, shouldShowPlayVideoButton = true, }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [videoLoadingFailed, setVideoLoadingFailed] = useState(false);
    const [isStarted, setIsStarted] = useState(false);
    const [player, setPlayer] = useState({ pause: () => { }, play: () => { }, options_: {} });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const videoPlayerRef = useRef();
    const playVideo = () => {
        if (player) {
            player.play();
        }
        setIsPlaying(true);
    };
    const pauseVideo = () => {
        if (player) {
            player.pause();
        }
        setIsPlaying(false);
    };
    const handleOnClick = () => {
        if (!isPlaying) {
            playVideo();
        }
        else {
            pauseVideo();
        }
        if (!isStarted) {
            setIsStarted(true);
        }
    };
    const handleOnHide = () => {
        if (isPlaying) {
            pauseVideo();
            setIsPlaying(false);
        }
    };
    const handleOnShow = () => {
        if (autoplay && !videoLoadingFailed) {
            playVideo();
            setIsStarted(true);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSuccess = (success) => {
        var _a, _b;
        const { ref } = success;
        const videoPlayerRefNode = (_a = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.refNode;
        const videoElement = videoPlayerRefNode === null || videoPlayerRefNode === void 0 ? void 0 : videoPlayerRefNode.querySelector('video');
        videoElement === null || videoElement === void 0 ? void 0 : videoElement.setAttribute('muted', true);
        if (loop) {
            videoElement === null || videoElement === void 0 ? void 0 : videoElement.setAttribute('loop', 'loop');
        }
        (_b = ref === null || ref === void 0 ? void 0 : ref.catalog) === null || _b === void 0 ? void 0 : _b.getVideo(videoId, (error) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (!error) {
                setPlayer(ref);
                try {
                    if (((_a = ref === null || ref === void 0 ? void 0 : ref.mediainfo) === null || _a === void 0 ? void 0 : _a.id) !== undefined && ((_b = ref === null || ref === void 0 ? void 0 : ref.mediainfo) === null || _b === void 0 ? void 0 : _b.duration) !== undefined) {
                        const uploadDate = (_c = ref === null || ref === void 0 ? void 0 : ref.mediainfo) === null || _c === void 0 ? void 0 : _c.publishedAt;
                        const dataVideoId = (_d = ref === null || ref === void 0 ? void 0 : ref.mediainfo) === null || _d === void 0 ? void 0 : _d.id;
                        const embedUrl = `https://players.brightcove.net/${(_e = ref === null || ref === void 0 ? void 0 : ref.bcinfo) === null || _e === void 0 ? void 0 : _e.accountId}/${ref === null || ref === void 0 ? void 0 : ref.bcinfo.playerId}_${(_f = ref === null || ref === void 0 ? void 0 : ref.bcinfo) === null || _f === void 0 ? void 0 : _f.embedId}/index.html?videoId=${dataVideoId}`;
                        const durationNum = (_g = ref === null || ref === void 0 ? void 0 : ref.mediainfo) === null || _g === void 0 ? void 0 : _g.duration;
                        const duration = `PT${Math.round(durationNum)}S`;
                        const thumbnailUrl = (posterImage === null || posterImage === void 0 ? void 0 : posterImage.src) || ((_h = ref === null || ref === void 0 ? void 0 : ref.mediainfo) === null || _h === void 0 ? void 0 : _h.poster);
                        setVideoSchema({
                            embedUrl,
                            uploadDate,
                            duration,
                            thumbnailUrl,
                            dataVideoId,
                            description,
                            name,
                        });
                        const videoElement2 = videoPlayerRefNode === null || videoPlayerRefNode === void 0 ? void 0 : videoPlayerRefNode.querySelector('video-js');
                        videoElement2 === null || videoElement2 === void 0 ? void 0 : videoElement2.setAttribute('autoplay', true);
                        if (posterImage) {
                            videoElement === null || videoElement === void 0 ? void 0 : videoElement.removeAttribute('poster');
                        }
                        const vjsLoadingSpinner = videoPlayerRefNode === null || videoPlayerRefNode === void 0 ? void 0 : videoPlayerRefNode.querySelector('.vjs-loading-spinner .vjs-control-text');
                        if (vjsLoadingSpinner) {
                            vjsLoadingSpinner.innerHTML = labels.videoLoadingText;
                        }
                        if (trackingData) {
                            trackVideo({
                                brand: trackingData.brand,
                                currency: trackingData.currency,
                                market: trackingData.market,
                                touchpoint: trackingData.touchpoint,
                                locale: trackingData.locale,
                                pageId: trackingData.pageId,
                                pageType: trackingData.pageType,
                                pageCategory: trackingData.pageCategory,
                                pageCategoryPath: trackingData.pageCategoryPath,
                                videoElement,
                                duration: durationNum,
                                articleCode: trackingData.articleCode,
                                event_type: trackingData.event_type,
                                event_category: trackingData.event_category,
                            });
                        }
                    }
                }
                catch (e) {
                    // just in case brightcove player does not work
                    console.error('Error with updating video player html', e);
                }
            }
            else {
                setVideoLoadingFailed(true);
                setIsStarted(false);
            }
        });
    };
    const onFailure = () => {
        console.error('Error with loading product video from Brightcove');
        setVideoLoadingFailed(true);
    };
    const defaultIntersectionObserverOptions = {
        root: isClient() ? document : null,
        rootMargin: '0px 0px 150% 0px',
        threshold: 1,
    };
    return (React.createElement("figure", { className: cn(className, styles.pdpVideo) },
        React.createElement(IntersectionVisible, { isActive: true, onShow: handleOnShow, onHide: handleOnHide, options: Object.assign(Object.assign({}, defaultIntersectionObserverOptions), intersectionVisibleOptions) },
            React.createElement(ReactPlayerLoader, { accountId: options.accountId, playerId: options.playerId, videoId: videoId, onSuccess: onSuccess, onFailure: onFailure, ref: videoPlayerRef })),
        !isStarted && posterImage && (React.createElement("div", { className: styles.posterImage },
            React.createElement(Image, { altText: posterImage.altText, src: posterImage.src, sources: posterImage.sources }))),
        shouldShowPlayVideoButton && !videoLoadingFailed && (React.createElement(IconButton, { onClick: handleOnClick, className: styles.videoOverlay, title: isPlaying ? labels.pauseButtonText : labels.playButtonText, "data-testid": "playVideoToggleOverlay", iconElement: isPlaying ? React.createElement(MediaPauseIconMedium, null) : React.createElement(MediaPlayIconMedium, null) }, isPlaying ? labels.pauseButtonText : labels.playButtonText))));
};
export default ProductVideo;
//# sourceMappingURL=ProductVideo.js.map